export const SAVE_MESSAGES = "SAVE_MESSAGES";
export const GET_MESSAGES = "GET_MESSAGES";
export const SET_ID_CASE = "SET_ID_CASE";
export const CLEAR_LIST_MESSAGES = "CLEAR_LIST_MESSAGES";
export const UPDATE_UNREAD_MESSAGES = "UPDATE_UNREAD_MESSAGES";

export const saveMessages = (messages) => ({
	type: SAVE_MESSAGES,
	messages
});

export const getMessages = (listMessages) => ({
	type : GET_MESSAGES,
	listMessages
});

export const setIdCase = (idCase) => ({
	type : SET_ID_CASE,
	idCase
});

export const clearListMessages = () => ({
	type: CLEAR_LIST_MESSAGES
});

export const updateUnreadMessages = (idCase) => ({
	type : UPDATE_UNREAD_MESSAGES,
	idCase
});